const githubLink="https://github.com/ManujaDewmina";
const instaLink="https://www.instagram.com/mr_manchi_?igsh=MWx5MGhzcXc2czh2Ng%3D%3D&utm_source=qr";
const linkedInLink="https://www.linkedin.com/in/manuja-dewmina-8b0173205";
const emailLink="mailto:manuja1bc@gmail.com";

const profileLinks={
    githubLink,
    instaLink,
    linkedInLink,
    emailLink
}
const SocialData=profileLinks;
export default SocialData;

